import icons from 'components/SocialMediaIcons';


export const SOCIAL_MEDIA_LINKS = {
  LOCALE_DEFAULT: {
    TIKTOK: { DEFAULT: null },
    TWITTER: {
      DEFAULT: 'https://www.twitter.com/cam4',
      MALE: 'https://twitter.com/Cam4_Gay',
    },
    FACEBOOK: {
      DEFAULT: 'https://www.facebook.com/cam4.gay',
      MALE: 'https://www.facebook.com/cam4.gay',
      SHEMALE: 'https://www.facebook.com/cam4.gay',
    },
    YOUTUBE: { DEFAULT: 'https://www.youtube.com/c/cam4official?sub_confirmation=1' },
    TUMBLR: {
      DEFAULT: 'http://cam4inside.tumblr.com/',
      MALE: 'http://cam4hard.tumblr.com/',
    },
    SNAPCHAT: { DEFAULT: 'https://www.snapchat.com/add/cam4snaps' },
    INSTAGRAM: { DEFAULT: 'https://www.instagram.com/officialcam_4/' },
    TELEGRAM: { DEFAULT: null },
  },

  LOCALE_EN: { TIKTOK: { DEFAULT: 'https://www.tiktok.com/@c4culture' } },

  LOCALE_UK: {
    TWITTER: {
      DEFAULT: 'https://twitter.com/Cam4_UK',
      MALE: 'https://twitter.com/Cam4_UK',
    },
  },

  LOCALE_FR: {
    TWITTER: {
      DEFAULT: 'http://twitter.com/Cam4_FR',
      MALE: 'https://twitter.com/Cam4_gayFR',
    },
    FACEBOOK: {
      DEFAULT: null,
      MALE: 'https://www.facebook.com/cam4gayFrance/',
      SHEMALE: null,
      ALL: 'https://www.facebook.com/cam4gayFrance/',
    },
    YOUTUBE: { DEFAULT: 'https://www.youtube.com/channel/UCaTVa8OizOXUHZdOCe8p_mQ' },
    INSTAGRAM: {
      DEFAULT: null,
      MALE: null,
      SHEMALE: null,
    },
    TUMBLR: { DEFAULT: null },
  },

  LOCALE_ES: {
    TWITTER: {
      DEFAULT: 'https://twitter.com/Cam4_ES',
      MALE: 'https://twitter.com/cam4gayesp',
    },
    FACEBOOK: {
      DEFAULT: null,
      MALE: null,
      SHEMALE: null,
    },
    INSTAGRAM: {
      DEFAULT: null,
      MALE: null,
      SHEMALE: null,
    },
    TUMBLR: { DEFAULT: null },
  },

  LOCALE_PT: {
    TWITTER: {
      DEFAULT: 'https://twitter.com/br_cam4',
      MALE: 'https://twitter.com/br_cam4',
    },
  },

  LOCALE_IT: {
    TIKTOK: {
      DEFAULT: 'https://www.tiktok.com/@c4culture',
      MALE: null,
      SHEMALE: 'https://www.tiktok.com/@c4culture',
      ALL: 'https://www.tiktok.com/@c4culture',
      COUPLE: 'https://www.tiktok.com/@c4culture',
    },
    TWITTER: {
      DEFAULT: 'https://twitter.com/Cam4_IT',
      MALE: 'https://twitter.com/cam4_gay',
    },
    FACEBOOK: {
      DEFAULT: null,
      MALE: null,
      SHEMALE: null,
    },
    YOUTUBE: { DEFAULT: 'https://www.youtube.com/channel/UC0Q2hKqRKEqFxmldIyQGtww' },
    INSTAGRAM: { DEFAULT: 'https://www.instagram.com/cam4__italia/' },
    TUMBLR: { DEFAULT: null },
    TELEGRAM: {
      DEFAULT: 'https://t.me/+2ZPgYHLjRFg2NDg0',
      MALE: null,
      SHEMALE: 'https://t.me/+2ZPgYHLjRFg2NDg0',
      ALL: 'https://t.me/+2ZPgYHLjRFg2NDg0',
      COUPLE: 'https://t.me/+2ZPgYHLjRFg2NDg0',
    },
  },

  LOCALE_DE: {
    TWITTER: {
      DEFAULT: 'https://twitter.com/Cam4_DE',
      MALE: 'https://twitter.com/Cam4_DE',
    },
    FACEBOOK: {
      DEFAULT: 'https://www.facebook.com/pages/Cam4-Germany/188943787859465',
      MALE: '',
    },
    TIKTOK: { DEFAULT: 'https://www.tiktok.com/@c4_harry' },
  },

  LOCALE_NL: {
    TWITTER: {
      DEFAULT: 'https://twitter.com/Cam4_NL',
      MALE: 'https://twitter.com/Cam4_NL',
    },
    FACEBOOK: {
      DEFAULT: 'https://www.facebook.com/cam4.gay',
      MALE: 'https://www.facebook.com/cam4.gay',
      SHEMALE: '',
    },
  },
  LOCALE_SV: { TWITTER: { DEFAULT: 'https://twitter.com/Cam4_SE' } },
};

export const SOCIAL_MEDIA = {
  TIKTOK: 'tiktok',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TUMBLR: 'tumblr',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  SNAPCHAT: 'snapchat',
  TELEGRAM: 'telegram',
};

export const SOCIAL_MEDIA_ICONS = {
  FACEBOOK: icons.Facebook,
  INSTAGRAM: icons.Instagram,
  SNAPCHAT: icons.Snapchat,
  TELEGRAM: icons.Telegram,
  TIKTOK: icons.Tiktok,
  TUMBLR: icons.Tumblr,
  TWITTER: icons.Twitter,
  YOUTUBE: icons.Youtube,
};

export const SOCIAL_MEDIA_BY_LANGUAGE = {
  EN: {
    TIKTOK: 'tiktok',
    TWITTER: 'twitter',
    YOUTUBE: 'youtube',
    SNAPCHAT: 'snapchat',
  },
};

export const SOCIAL_MEDIA_SETTINGS = {
  GENDER_PREFERENCE: {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    SHEMALE: 'SHEMALE',
    DEFAULT: 'DEFAULT',
  },
  LOCALE: {
    LOCALE_SPECIFIC: 'LOCALE_',
    LOCALE_DEFAULT: 'LOCALE_DEFAULT',
  },
};
